import React from "react"
import {
  ChefHatIcon,
  CheckmarkCircleIcon,
  HomeIcon,
  LongListIcon,
  ScooterIcon,
  TakeawayBagIcon,
} from "@/components/icons"
import type { WorkflowStageIconKey } from "@/domain/order/order-details-stepper"

export type WorkflowStageIconProps = React.SVGProps<SVGSVGElement> & {
  iconKey: WorkflowStageIconKey
}

const ICON_MAP: Record<WorkflowStageIconKey, React.FC<React.SVGProps<SVGSVGElement>>> = {
  order: LongListIcon,
  confirmed: CheckmarkCircleIcon,
  preparing: ChefHatIcon,
  ready: TakeawayBagIcon,
  delivery: ScooterIcon,
  delivered: HomeIcon,
}

export function WorkflowStageIcon({ iconKey, ...props }: WorkflowStageIconProps) {
  const Icon = ICON_MAP[iconKey] ?? LongListIcon
  return <Icon {...props} />
}
